<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card
            :loading="actionLoading"
        >
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="isEditable && showOnly">
                        Produkt - <strong>{{ setProductData.product.name }}</strong>
                    </template>
                    <template v-else>
                        <template v-if="isNewSet">
                            Dodaj produkt
                        </template>
                        <template v-else>
                            Edycja produktu - <strong>{{ setProductData.product.name }}</strong>
                        </template>
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="setProductModel.product"
                                :items="availableProducts"
                                label="Produkt"
                                return-object
                                outlined
                                dense
                                item-text="name"
                                item-value="id"
                                :readonly="!isNewSet"
                                :error-messages="setProductErrors"
                                @change="productChanged"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="setProductModel.amount"
                                :error-messages="setProductAmountErrors"
                                label="Ilość"
                                outlined
                                dense
                                persistent-hint
                                required
                                @input="$v.setProductModel.amount.$touch()"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>


            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    :disabled="isInvalid"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, minValue, integer } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'

export default {
    name: 'CampaignSetProductDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        isEditable: {
            type: Boolean
        },
        setProductData: {
            type: Object,
            default: null
        },
        productList: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            setProductModel: {
                id: null,
                product: null,
                productId: null,
                amount: null,
            },
            actionLoading: false,
        }
    },
    validations() {
        let rules = {
            setProductModel: {
                product: {
                    required,
                },
                amount: {
                    required,
                    integer,
                    minValue: minValue(1),
                },
            },
        }

        return rules
    },
    computed: {
        isNewSet() {
            return isEmpty(this.setProductData)
        },
        availableProducts() {
            if (this.isNewSet) {
                return this.productList
            }

            return [ this.setProductModel.product ]
        },
        setProductErrors() {
            const errors = []

            if (!this.$v.setProductModel.product.$dirty) return errors
            !this.$v.setProductModel.product.required && errors.push('Proszę podać nazwę zestawu.')

            return errors
        },
        setProductAmountErrors() {
            const errors = []

            if (!this.$v.setProductModel.amount.$dirty) return errors
            !this.$v.setProductModel.amount.required && errors.push('Proszę podać ilość produktu.')

            if (!this.$v.setProductModel.amount.minValue || !this.$v.setProductModel.amount.integer) {
                errors.push('Proszę podać całkowitą dodatnią liczbę produktów.')
            }

            return errors
        },
        isInvalid() {
            return this.$v.$invalid
        }
    },
    watch: {
        setProductData(value) {
            if (!isEmpty(value)) {
                this.setProductModel = {
                    id: value.id,
                    product: value.product,
                    productId: value.productId,
                    amount: value.amount,
                }
                this.$v.$touch()
            }
        }
    },
    methods: {
        productChanged() {
            this.setProductModel.productId = this.setProductModel.product.id
        },
        onSave() {
            this.setProductModel.amount = parseInt(this.setProductModel.amount)
            this.$emit('on-save', this.setProductModel)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.actionLoading = false
                this.setInitialData()
            }, 500)

            this.$emit('on-close')
        },
        setInitialData() {
            this.setProductModel = {
                id: null,
                product: null,
                productId: null,
                amount: null,
            }
            this.$v.$reset()
        }
    }
}
</script>
